import { Injectable } from '@angular/core';
import { BaseService } from "./base.service";
import { Http } from '@angular/http';
import * as Enum from '../utils/enums';
import { Observable } from "rxjs";
import { RequestBuilder } from '../classes/request-builder';

@Injectable()
export class CommessaService extends BaseService {


  /**
     * Costruttore
     * @param http Servizio di richieste HTTP 
     */
  constructor(http: Http) {
    super(http);
  }

  /**
   * Save new Commessa
   * @param reqBuilder 
   */
  save(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('commessa/save', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * Get list of Commesse
   * @param reqBuilder 
   */
  getAllCommesse(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('commessa/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * Get list of Commesse
   * @param reqBuilder 
   */
  getAllCommesseAllegati(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('/AllegatoUtente/FetchInterventi', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * Get list of Commesse
   * @param reqBuilder 
   */
  getAllInterventi(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('commessa/fetchInterventi', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * Get data of one commessa
   * @param reqBuilder 
   */
  getCommessaData(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('commessa/fetchSingle', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * Get all richieste of commessa
   * @param reqBuilder 
   */
  getRichiesteCommessa(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('commessa/fetchAllRichieste', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  getCommessaByGruppo(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('commessa/FetchInterventiByGruppo', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * Get all esecutori of commessa
   * @param reqBuilder 
   */
  getEsecutoriCommessa(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('commessa/fetchAllEsecutori', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * commessa save SAL
   * @param reqBuilder 
   */
  saveSALofCommessa(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('SALCommessa/save', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * commessa delete SAL
   * @param reqBuilder 
   */
  deleteSALofCommessa(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('SALCommessa/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * commessa save Pagamento
   * @param reqBuilder 
   */
  savePagamentoforCommessa(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('PagamentoCommessa/Save', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * commessa delete Pagamento
   * @param reqBuilder 
   */
  deletePagamentoforCommessa(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('PagamentoCommessa/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * upload file
   * @param file file upload
   * @param pagamentoId id of pagamento
   * @param nomeFile name of file
   */
  uploadAllegatoPagamento(file: any, nomeFile: string, pagamentoId: string): Observable<any> {
    return this.doUploadPagamento('allegato/savePagamento', file, Enum.CONTENT_TYPE_ENUM.APPLICATION_OCTET_STREAM, pagamentoId, nomeFile);
  }

  /**
   * upload file
   * @param file file upload
   * @param salId id of sal
   * @param nomeFile name of file
   */
  uploadAllegatoSAL(file: any, nomeFile: string, salId: string): Observable<any> {
    return this.doUploadSAL('allegato/saveSALCommessa', file, Enum.CONTENT_TYPE_ENUM.APPLICATION_OCTET_STREAM, salId, nomeFile);
  }



  /**
   * Get list of richieste by commesse
   * @param reqBuilder 
   */
  getAllRichiesteCommesse(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('commessa/fetchRichiestaCommesse', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }


  /**
  * Get list of Cantieri  by commesse
  * @param reqBuilder 
  */
  getAllCantieriCommesse(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('commessa/fetchCantiereCommesse', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

  /**
   * associa la commessa ad un gruppo 
   * aggiunto in data 07/09/2020
   * @param reqBuilder 
   */
  associaCommessaAGruppo(reqBuilder?: RequestBuilder) {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('commessa/associagruppi', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }


  /**
   * commessa delete 
   * @param reqBuilder 
   */
  deleteCommessa(reqBuilder?: RequestBuilder): Observable<any> {
    let payload;
    if (reqBuilder) {
      payload = reqBuilder;
    }
    return this.doPost('commessa/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
  }

}
